import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "selectedSubject" }

import { useSubjectStore } from '@/store/subjectStore';
  import { computed } from 'vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectedSubject',
  setup(__props) {

  const subjectStore = useSubjectStore();
  const selectedSubject = computed(() => subjectStore.selectedSubject);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(selectedSubject.value.name), 1)
  ]))
}
}

})